module.exports = __webpack_public_path__ + "static/aboriginal-c824891d99ebcb71c304a1c2e6d7cab4.png";